import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "data-item__header" };
const _hoisted_2 = { class: "data-item__nav" };
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
const _hoisted_5 = ["title"];
const _hoisted_6 = ["title"];
const _hoisted_7 = { class: "data-item__topic" };
const _hoisted_8 = { class: "data-item__title" };
const _hoisted_9 = { class: "data-item__meta" };
const _hoisted_10 = { class: "data-item__facts" };
const _hoisted_11 = { class: "data-item__actions" };
const _hoisted_12 = { class: "data-item__content" };
const _hoisted_13 = {
    key: 0,
    class: "data-item__section"
};
const _hoisted_14 = { class: "data-item__section-title" };
const _hoisted_15 = {
    key: 1,
    class: "data-item__section order__add-items"
};
const _hoisted_16 = { class: "order__comment" };
const _hoisted_17 = {
    key: 0,
    class: "order__footer"
};
const _hoisted_18 = { class: "order__purchase" };
const _hoisted_19 = {
    key: 0,
    class: "order__validation"
};
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
import carts from "@astina/paloma-shop-common-ui/src/services/CartRepository";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import config from '../services/PortalConfig';
import PurchaseOrder from "../commands/PurchaseOrder";
import { updateCartItems } from "../commands/UpdateCartItems";
import { selectCartDeliveryLocation } from "../commands/SelectCartDeliveryLocation";
import { createDeliveryLocation } from "../commands/CreateDeliveryLocation";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import CartDeliveryLocations from "@astina/paloma-shop-common-ui/src/components/CartDeliveryLocations.vue";
import OrderTotal from "@astina/paloma-shop-common-ui/src/components/OrderTotal.vue";
import Fact from "@astina/paloma-common-ui/src/components/Fact.vue";
import CartDeliveryDate from "@astina/paloma-shop-common-ui/src/components/CartDeliveryDate.vue";
import CartItemAdd from "@astina/paloma-shop-common-ui/src/components/CartItemAdd.vue";
import CartDeliveryGroup from "@astina/paloma-shop-common-ui/src/components/CartDeliveryGroup.vue";
import orderUtils from "@astina/paloma-shop-common-ui/src/services/OrderUtils";
import userSettings, {} from '@astina/paloma-common-ui/src/services/UserSettings';
import CartModificationsModal from "@astina/paloma-shop-common-ui/src/components/CartModificationsModal.vue";
import CartComment from "@astina/paloma-shop-common-ui/src/components/CartComment.vue";
import CartCustomerOrderNumber from "@astina/paloma-shop-common-ui/src/components/CartCustomerOrderNumber.vue";
import { setCartComment } from "../commands/SetCartComment";
import { setCartCustomerOrderNumber } from "../commands/SetCartCustomerOrderNumber";
import DeleteOrderDraft from "../commands/DeleteOrderDraft";
import { setCartDeliveryScheme } from "../commands/SetCartDeliveryScheme";
import { addCartItems } from "../commands/AddCartItems";
import { addWatchlistItem } from "../commands/AddWatchlistItems";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartView',
    emits: [
        'close',
        'prev',
        'next'
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const router = useRouter();
        const emit = __emit;
        const settings = userSettings('paloma-ui.portal.orders');
        const order = ref(null);
        const deliveries = ref([]);
        const orderTotals = ref(null);
        const purchaseOrder = ref(null);
        const deleteOrder = ref(null);
        const itemsLoading = ref(false);
        const userSettingsValue = ref(null);
        const finalizeOperation = ref(null);
        const configValue = config;
        const allowOrderingUnitSelection = ref(config.articleOrderingUnitSelection === 'allow');
        const showCartComment = ref(config.showCartComment);
        const showCartCustomerOrderNumber = ref(config.showCartCustomerOrderNumber);
        const cartCustomerOrderNumberMaxLength = ref(config.cartCustomerOrderNumberMaxLength);
        const addCartItemsFunction = addCartItems;
        const addWatchlistItemFunction = addWatchlistItem;
        onMounted(() => {
            loadOrder();
            events.$on('command.add_cart_items.success', onAddCartItems);
            events.$on('cart-update', onCartUpdate);
            userSettingsValue.value = settings.get({ expanded: false });
        });
        onUnmounted(() => events.$off('command.add_cart_items.success', onAddCartItems));
        onUnmounted(() => events.$off('cart-update', onCartUpdate));
        watch(() => route.params, loadOrder);
        function loadOrder() {
            order.value = null;
            const cartId = RouterUtils.singleParam(route, 'id');
            if (cartId && cartId !== '') {
                _loadOrder(cartId);
            }
        }
        function _loadOrder(cartId) {
            carts
                .getCart(cartId)
                .then(cart => {
                order.value = cart;
                purchaseOrder.value = new PurchaseOrder(order.value.id);
                deleteOrder.value = new DeleteOrderDraft(order.value.id);
                onOrderUpdate(cart);
                events.$emit('cart-loaded', cart);
            })
                .catch(() => {
                alerts.warning(trans('order.not_found'), undefined, { timeout: 5000 });
                router.push({ name: 'orders' });
            });
        }
        function onOrderUpdate(orderDraft) {
            orderTotals.value = createOrderTotals(orderDraft);
            deliveries.value = createDeliveries(orderDraft);
            order.value.context = orderDraft.context;
            updateFinalizeOperation(orderDraft);
        }
        function onCartUpdate(cart) {
            if (cart.id === order.value?.id) {
                onOrderUpdate(cart);
            }
        }
        function onItemQuantityChange(item, quantity) {
            if (order.value === null ||
                (item.quantity === quantity.quantity) && (item.portions === quantity.portions)) {
                return;
            }
            updateCartItems([{
                    itemId: item.id,
                    quantity: quantity.quantity,
                    portions: quantity.portions,
                }], order.value.id)
                .then((cart) => _loadOrder(cart.id));
        }
        function onItemParamsChange(item, params) {
            if (order.value === null) {
                return;
            }
            updateCartItems([{
                    itemId: item.id,
                    quantity: item.quantity,
                    parameters: params,
                }], order.value.id)
                .then((cart) => _loadOrder(cart.id));
        }
        function saveDeliveryLocation(data) {
            return createDeliveryLocation(data);
        }
        function onSelectDeliveryLocation(deliveryLocation) {
            selectCartDeliveryLocation(order.value.id, deliveryLocation.id)
                .then(updateOrderPartial);
        }
        function onSelectDeliveryScheme(scheme) {
            setCartDeliveryScheme(order.value.id, scheme)
                .then(updateOrderPartial);
        }
        function removeCartItem(item) {
            onItemQuantityChange(item, { quantity: 0 });
        }
        function onAddCartItems(cart) {
            if (order.value && cart.id === order.value.id) {
                itemsLoading.value = true;
                carts
                    .getCart(order.value.id)
                    .then(updateOrderPartial)
                    .finally(() => itemsLoading.value = false);
            }
        }
        function onCommentUpdate(comment) {
            setCartComment(order.value.id, comment || null);
        }
        function onCustomerOrderNumberUpdate(customerOrderNumber) {
            setCartCustomerOrderNumber(order.value.id, customerOrderNumber || null);
        }
        function updateOrderPartial(orderParam) {
            order.value.items = orderParam.items;
            order.value.shippingMethod = orderParam.shippingMethod;
            order.value.expectedDeliveries = orderParam.expectedDeliveries;
            order.value._operations = orderParam._operations;
            onOrderUpdate(orderParam);
        }
        function toggleExpanded() {
            if (userSettingsValue.value) {
                userSettingsValue.value.expanded = !userSettingsValue.value.expanded;
                settings.set(userSettingsValue.value);
            }
        }
        function updateFinalizeOperation(order) {
            finalizeOperation.value = (order._operations || [])
                .find(op => op.name === 'finalize') || null;
        }
        function createOrderTotals(order) {
            return orderUtils.createOrderTotals(order);
        }
        function createDeliveries(order) {
            if (order.expectedDeliveries.length === 0) {
                return [{
                        deliveryArrangement: { targetDate: order.shippingMethod && order.shippingMethod.targetDate || null },
                        itemIds: [],
                        items: [],
                        itemsPricing: order.itemsPricing,
                    }];
            }
            return order.expectedDeliveries
                .map(group => {
                const items = group.itemIds
                    .map(id => order.items.find(item => id === item.id))
                    .filter(item => item !== undefined);
                return {
                    deliveryArrangement: group.deliveryArrangement,
                    itemIds: group.itemIds,
                    itemsPricing: group.itemsPricing,
                    items: items,
                };
            });
        }
        // --
        function closeView() {
            emit('close');
        }
        function prevItem() {
            emit('prev');
        }
        function nextItem() {
            emit('next');
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-item order", { 'order--loading': !order.value, 'order--items-loading': itemsLoading.value, 'data-item--expanded': userSettingsValue.value && userSettingsValue.value.expanded }])
            }, [
                _createElementVNode("header", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (toggleExpanded()), ["prevent"])),
                            class: "data-item__nav-item data-item__expand",
                            title: _ctx.$t(userSettingsValue.value && userSettingsValue.value.expanded ? 'collapse' : 'expand'),
                            href: ""
                        }, [
                            _createVNode(_component_icon, {
                                name: userSettingsValue.value && userSettingsValue.value.expanded ? 'compress' : 'expand'
                            }, null, 8, ["name"])
                        ], 8, _hoisted_3),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (prevItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            title: _ctx.$t('prev'),
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "angle-left" })
                        ], 8, _hoisted_4),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (closeView()), ["prevent"])),
                            class: "data-item__nav-item",
                            title: _ctx.$t('close'),
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "times" })
                        ], 8, _hoisted_5),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (nextItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            title: _ctx.$t('next'),
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "angle-right" })
                        ], 8, _hoisted_6)
                    ]),
                    _cache[11] || (_cache[11] = _createTextVNode()),
                    (order.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$dateTime(order.value.created)), 1),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t('orders.create_draft')), 1),
                            _cache[10] || (_cache[10] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createVNode(Fact, {
                                        label: _ctx.$t('order.status'),
                                        value: _ctx.$t('order.status.draft'),
                                        variant: 'status-draft'
                                    }, null, 8, ["label", "value"]),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    (order.value.customer && order.value.customer.lastName)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 0,
                                            label: _ctx.$t('created_by'),
                                            value: order.value.customer.firstName + ' ' + order.value.customer.lastName,
                                            variant: "info"
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_11, [
                                    (deleteOrder.value)
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 0,
                                            command: deleteOrder.value,
                                            classes: ['button', 'button--light']
                                        }, null, 8, ["command"]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !order.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                _createElementVNode("div", _hoisted_12, [
                    (order.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (order.value.items.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t('orders.delivery')), 1),
                                    _cache[12] || (_cache[12] = _createTextVNode()),
                                    _createVNode(CartDeliveryLocations, {
                                        order: order.value,
                                        onSelectLocation: onSelectDeliveryLocation,
                                        "create-function": saveDeliveryLocation,
                                        display: _unref(config).cartDeliveryLocations
                                    }, null, 8, ["order", "display"]),
                                    _cache[13] || (_cache[13] = _createTextVNode()),
                                    _createVNode(CartDeliveryDate, {
                                        order: order.value,
                                        "visible-weeks": _unref(configValue).cartDeliveryDaysVisibleWeeks,
                                        "max-weeks": _unref(configValue).cartDeliveryDaysMaxWeeksAhead,
                                        onSelectScheme: onSelectDeliveryScheme
                                    }, null, 8, ["order", "visible-weeks", "max-weeks"])
                                ]))
                                : _createCommentVNode("", true),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveries.value, (delivery, index) => {
                                return (_openBlock(), _createBlock(CartDeliveryGroup, {
                                    key: index,
                                    delivery: delivery,
                                    order: order.value,
                                    loading: itemsLoading.value,
                                    "allow-ordering-unit-selection": allowOrderingUnitSelection.value,
                                    "add-cart-items": _unref(addCartItemsFunction),
                                    "add-watchlist-item": _unref(addWatchlistItemFunction),
                                    onItemQuantityChange: onItemQuantityChange,
                                    onItemParamsChange: onItemParamsChange,
                                    onItemRemove: removeCartItem
                                }, null, 8, ["delivery", "order", "loading", "allow-ordering-unit-selection", "add-cart-items", "add-watchlist-item"]));
                            }), 128)),
                            _cache[16] || (_cache[16] = _createTextVNode()),
                            (order.value.expectedDeliveries.length > 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createVNode(CartItemAdd, {
                                        order: order.value,
                                        "add-cart-items": _unref(addCartItemsFunction),
                                        "add-watchlist-item": _unref(addWatchlistItemFunction),
                                        "allow-ordering-unit-selection": allowOrderingUnitSelection.value
                                    }, null, 8, ["order", "add-cart-items", "add-watchlist-item", "allow-ordering-unit-selection"])
                                ]))
                                : _createCommentVNode("", true),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_16, [
                                (showCartComment.value)
                                    ? (_openBlock(), _createBlock(CartComment, {
                                        key: 0,
                                        order: order.value,
                                        onChange: onCommentUpdate
                                    }, null, 8, ["order"]))
                                    : _createCommentVNode("", true),
                                _cache[14] || (_cache[14] = _createTextVNode()),
                                (showCartCustomerOrderNumber.value)
                                    ? (_openBlock(), _createBlock(CartCustomerOrderNumber, {
                                        key: 1,
                                        "max-length": cartCustomerOrderNumberMaxLength.value,
                                        order: order.value,
                                        onChange: onCustomerOrderNumberUpdate
                                    }, null, 8, ["max-length", "order"]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                _cache[21] || (_cache[21] = _createTextVNode()),
                (order.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (orderTotals.value)
                            ? (_openBlock(), _createBlock(OrderTotal, {
                                key: 0,
                                currency: order.value.currency,
                                totals: orderTotals.value,
                                "tax-included": order.value.taxIncluded
                            }, null, 8, ["currency", "totals", "tax-included"]))
                            : _createCommentVNode("", true),
                        _cache[19] || (_cache[19] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_18, [
                            (finalizeOperation.value && !finalizeOperation.value.available && order.value.items.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalizeOperation.value.validation?.errors, (error, index) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                            key: index,
                                            class: "order__validation-message"
                                        }, _toDisplayString(_ctx.$t('errors.' + error.code, error.params)), 1));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true),
                            _cache[18] || (_cache[18] = _createTextVNode()),
                            (purchaseOrder.value)
                                ? (_openBlock(), _createBlock(CommandButton, {
                                    key: 1,
                                    command: purchaseOrder.value,
                                    disabled: !finalizeOperation.value || !finalizeOperation.value.available,
                                    classes: ['button', 'button--large']
                                }, null, 8, ["command", "disabled"]))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _cache[22] || (_cache[22] = _createTextVNode()),
                (order.value)
                    ? (_openBlock(), _createBlock(CartModificationsModal, {
                        key: 1,
                        order: order.value
                    }, null, 8, ["order"]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
